"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/languageService',["require", "exports", "controllers/languageController"], function (require, exports, languageController) {
    "use strict";

    var LanguageService = function () {
        function LanguageService() {
            _classCallCheck(this, LanguageService);
        }

        _createClass(LanguageService, [{
            key: "change",
            value: function change(language) {
                return languageController.change({ language: language }).done(this.languageChangeSuccess.bind(this));
            }
        }, {
            key: "languageChangeSuccess",
            value: function languageChangeSuccess() {
                window.location.reload();
            }
        }]);

        return LanguageService;
    }();

    return new LanguageService();
});
//# sourceMappingURL=languageService.js.map;
